import type { Eip1193Provider } from "ethers";
import { BaseWalletAdapter } from "./BaseWalletAdapter";

export class TrustWalletAdapter extends BaseWalletAdapter {
  readonly name = "trust";

  get installed(): boolean {
    return Boolean(this.resolveProvider());
  }

  protected resolveProvider(): Eip1193Provider | undefined {
    if (typeof window === "undefined") return undefined;
    const win = window as any;
    const isTrust = (p: any) => p?.isTrust || p?.isTrustWallet;
    if (win.ethereum?.providers?.length) {
      const found = win.ethereum.providers.find(isTrust);
      if (found) return found;
    }
    if (isTrust(win.ethereum)) return win.ethereum;
    if (win.trustwallet) return win.trustwallet;
    return undefined;
  }
}
